import React, { useEffect, useRef, useState } from "react";
import Lang from "../lib/Language";
import Mousetrap from "@timeedit/mousetrap";
import pkg from "../../package.json";
import { TimeEdit } from "../lib/TimeEdit";
import { useAppContext } from "../contexts/AppContext";
import { TComponent } from "../types/utils";

type TAboutProps = {
    close: () => void;
    supportInfoLines?: string[];
    showSupportText?: boolean;
};

const About: TComponent<TAboutProps> = (props) => {
    const appContext = useAppContext();
    const [showSupportInfoLines, setShowSupportInfoLines] = useState(props.showSupportText);
    const supportInfoRef = useRef<HTMLTextAreaElement>(null);

    // Mousetrap bindings and cleanup
    useEffect(() => {
        const previousMouseBindings = Mousetrap.unbindWithHelp("esc", true)[0];
        Mousetrap.bindWithHelp("esc", props.close);
        return () => {
            Mousetrap.unbindWithHelp("esc");
            Mousetrap.bindWithHelp("esc", previousMouseBindings);
        };
    }, []);

    // Focus on open
    useEffect(() => {
        if (showSupportInfoLines) {
            supportInfoRef.current?.focus();
        }
    });

    const toggleSupportInfo = () => {
        if (props.supportInfoLines) {
            setShowSupportInfoLines(!showSupportInfoLines);
        }
    };

    const copyToClipboard = () => {
        const text = supportInfoRef.current?.value;
        if (text) {
            navigator.clipboard.writeText(text);
        }
    };

    let name = "";
    if (TimeEdit.serverInfo?.server) {
        name = `Server ${TimeEdit.serverInfo.server.version}`;
    }

    let content = (
        <div className="versionText">
            <div className="logo" />
            {props.supportInfoLines?.[0]}
            <br />
            {name}
            <br />
            {TimeEdit.serverInfo?.copyright}
            <br />
            <button className="deprecated default" onClick={toggleSupportInfo}>
                {" "}
                {Lang.get("nc_about_more_info")}{" "}
            </button>
        </div>
    );

    const buildNumber =
        window.BUILD_NUM && window.BUILD_NUM !== "CI_BUILD_NUMBER"
            ? `, build ${window.BUILD_NUM}`
            : "";

    const infoLines = props.supportInfoLines
        ?.concat(" ")
        .concat(`Client: ${process.env.CLIENT_BUILD ?? "unknown"}${buildNumber}`)
        .concat(`Activity manager: ${pkg.dependencies["@timeedit/te-prefs-lib"]}`)
        .concat(`Exam plugin: ${pkg.dependencies["@timeedit/te-exam-plugin"]}`)
        .concat(`UI components: ${pkg.dependencies["@timeedit/ui-components"]}`)
        .concat(`URL: ${window.location}`)
        .concat(`Environment: ${appContext.env.serverEnv}`)
        .concat(`Region: ${appContext.env.serverRegion}`)
        .concat(`Platform: ${appContext.env.platformVersion}`);
    if (showSupportInfoLines) {
        content = (
            <div className="versionText">
                <textarea ref={supportInfoRef} readOnly={true} value={infoLines?.join("\n")} />
                <button className="deprecated modernButton" onClick={copyToClipboard}>
                    {Lang.get("cal_res_below_copy")}
                </button>
            </div>
        );
    }

    return (
        <div className="modal aboutDialog entryFadeIn">
            <div className="close" onClick={props.close}>
                X
            </div>
            <h1>{Lang.get("about_window_title")}</h1>
            <div className="inner">{content}</div>
        </div>
    );
};

export default About;
